export const getters = {
	cabinets: state => state.cabinets
}



// WEBPACK FOOTER //
// ./src/store/modules/Cabinets/getters.js